import React from 'react'
import {Tooltip, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Units from './Units';
import GridBlock from 'components/GridBlock';
import TextInput from "components/TextInput";
import Tr from "translations/Translations";
import getObjectValue from "libs/getObjectValue";
import clsx from 'clsx';
import INPUT_TYPE from "constants/INPUT_TYPE";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import Select from "components/Select";
import BooleanItems from "constants/BooleanItems";
import OfferSourceTypes from "constants/OfferSourceTypes";
import {ItemTypes} from "../../constants/itemTypes";
import WorkableIconAddButton from "components/button/WorkableIconAddButton";
import itemVatIcon from 'images/position_item_v_min.png'
import itemDescriptionIcon from 'images/position_item_o_min.png'
import itemQuantityIcon from 'images/position_item_m_min.png'
import itemOfferSourceIcon from 'images/position_item_i_min.png'

const style = theme => ({
    root: {
        '&>*': {
            flexBasis: 0,

            '&:not(:first-child)': {
                marginLeft: theme.spacing(2),
            },
            '&:last-child': {
                marginLeft: theme.spacing(2),
            },
            '&:nth-child(1)': {
                flexGrow: 4
            },
            '&:nth-child(2)': {
                flexGrow: 2
            },
            '&:nth-child(3)': {
                flexGrow: 1
            }
        }
    },
    rootWeight: {
        '&>*': {
            '&:nth-child(4)': {
                flexGrow: 1
            },
        }
    },
    imageDiv: {
        display: 'flex'
    },
    image: {
        objectFit: 'contain',
        width: '24px',
        height: '24px',
        padding: '12px 6px 12px 6px'
    }
})

function SingleVariant(
    {
        classes,
        formikProps,
        id,
        handleEditItem,
        weightVisible,
        optionalItemsEnabled
    }) {

    const nameId = `${id}.0.name`;
    const typeId = `${id}.0.type`;
    const descriptionId = `${id}.0.description`;
    const allowQuantityEditInOfferId = `${id}.0.allowQuantityEditInOffer`;
    const predefinedVatId = `${id}.0.offerVatPredefined`;
    const offerSourceTypeId = `${id}.0.offerSourceType`;
    const weightId = `${id}.0.weight`;
    const optionalItem = getObjectValue(`${id}.0.optionalItem`, formikProps.values, null);
    const editable = getObjectValue('_editable', formikProps.values, true);

    const predefinedVatValue = BooleanItems.find(bi => bi.value === getObjectValue(predefinedVatId, formikProps.values, null));
    const offerSourceTypeValue = OfferSourceTypes.find(bi => bi.value === getObjectValue(offerSourceTypeId, formikProps.values, null));
    const allowQuantityEditInOfferValue = BooleanItems.find(bi => bi.value === getObjectValue(allowQuantityEditInOfferId, formikProps.values, null));

    return (
        <GridBlock className={clsx(classes.root, {
            [classes.rootWeight]: weightVisible,
        })}>
            <TextInput
                id={nameId}
                label={Tr('name')}
                formikProps={formikProps}
                multiline
                disabled
            />
            <Units
                idPrefix={`${id}.0`}
                formikProps={formikProps}
                disabled
            />
            <Select
                label={Tr('position_type')}
                formikProps={formikProps}
                id={typeId}
                required
                disabled
                items={ItemTypes}
            />
            {weightVisible && <TextInput
                id={weightId}
                type={INPUT_TYPE.NUMBER_19}
                step="0.01"
                label={Tr('weight')}
                endAdornment={'%'}
                formikProps={formikProps}
                required
                disabled
            />}
            <div className={classes.imageDiv}>
                <Tooltip title={`${Tr('description')}: ${getObjectValue(descriptionId, formikProps.values, '--')}`}>
                    <img
                        className={classes.image}
                        src={itemDescriptionIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('offerVatPredefined')}: ${!!predefinedVatValue ? predefinedVatValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemVatIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('offerSourceType_long')}: ${!!offerSourceTypeValue ? offerSourceTypeValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemOfferSourceIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
                <Tooltip title={`${Tr('allowQuantityEditInOffer_long')}: ${!!allowQuantityEditInOfferValue ? allowQuantityEditInOfferValue.label : '--'}`}>
                    <img
                        className={classes.image}
                        src={itemQuantityIcon}
                        alt={Tr('ezam')}
                    />
                </ Tooltip>
            </div>
            {editable ?
                <WorkableIconEditButton
                    onClick={() => handleEditItem(0)}
                />
                :
                <WorkableIconPreviewButton
                    onClick={() => handleEditItem(0)}
                />
            }
            {optionalItemsEnabled && <WorkableIconAddButton
                tooltip={Tr('add_option')}
                onClick={() => handleEditItem(0, true)}
                disabled={!editable || !!optionalItem}
            />}
            <div/>
        </GridBlock>
    )
}

SingleVariant.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(SingleVariant);